import React, { Suspense, useRef } from "react";
// eslint-disable-next-line no-unused-vars
import { useInView, motion } from "framer-motion";

const Carousel = React.lazy(() => import("../components/Carousel"));

const TeamPage = ({ id }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id={id} className="h-full lg:h-screen bg-white pt-5">
      <div className="h-full flex flex-col lg:grid lg:grid-rows-1 lg:grid-cols-[1.5fr_2fr] justify-center relative">
        <motion.div
          className="p-5 pt-15 md:pt-17 lg:p-0 size-4/6 md:size-2/4 lg:size-full mx-auto"
          ref={ref}
          initial={{ opacity: 0, y: 80 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 80 }}
          transition={{ duration: 0.8, ease: "linear" }}
        >
          <img
            src="/team-img1.webp"
            alt="Team image 1"
            className="size-full rounded-2xl lg:rounded-none"
          />
        </motion.div>
        <div className="flex flex-col gap-5 justify-center items-center">
          <div className="flex w-full justify-center lg:self-end lg:w-3/4 absolute top-1 lg:translate-x-0 lg:left-0 lg:static">
            <p className=" text-black text-md xs:text-lg md:text-3xl lg:text-5xl font-semibold lg:font-medium lg:text-left text-balance">
              Co-Founders and Managing Partners
            </p>
          </div>
          <Suspense>
            <Carousel />
          </Suspense>
        </div>
      </div>
    </section>
  );
};

export default TeamPage;
